<template>
  <div>
    <Dialog :open="open" width="640" :persistent="false" @close="$emit('close')">
      <template v-slot:title>
        <FlexRow full-width justify="center">
          <Label size="h5" text="スカウトのデフォルト設定" bold />
        </FlexRow>
      </template>

      <template v-slot:default>
        <FlexColumn :space="4" class="px-8">
          <FlexColumn :space="0">
            <Label text="スカウト送付者" bold />
            <SelectField
                v-model="requestorId"
                :items="requestorItems"
                :outlined="false"
                class="pa-0 ma-0"
                simple
            />
          </FlexColumn>

          <FlexColumn :space="0">
            <Label text="メッセージテンプレート" bold />
            <FlexRow :space="2" align="center">
              <SelectField
                  v-model="templateId"
                  :items="templateItems"
                  :outlined="false"
                  simple
                  class="pa-0 mt-0"
              />
              <FlexRow>
                <Button
                    outlined
                    small
                    color="primary"
                    @click="openMessageTemplateCreateDialog = true"
                >
                  <Label text="新規" size="body-2" />
                </Button>
                <Button
                    outlined
                    small
                    color="primary"
                    @click="openMessageTemplateListDialog = true"
                >
                  <Label text="編集" size="body-2" />
                </Button>
              </FlexRow>
            </FlexRow>
          </FlexColumn>
        </FlexColumn>
      </template>
      <template v-slot:actions>
        <FlexRow full-width justify="center">
          <TextButton
              :primary="requestorId !== undefined"
              :disabled="requestorId === undefined"
              @click="handleSelect"
          >
            設定する
          </TextButton>
        </FlexRow>
      </template>
    </Dialog>
    <ScoutMessageTemplateCreateDialog
        :open="openMessageTemplateCreateDialog"
        :companyId="company.id"
        @close="openMessageTemplateCreateDialog = false"
    />
    <ScoutMessageTemplateListDialog
        :open="openMessageTemplateListDialog"
        :companyId="company.id"
        @close="openMessageTemplateListDialog = false"
    />
  </div>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import TextButton from "@/components/atoms/TextButton";
import FlexRow from "@/components/atoms/FlexRow";
import SelectField from "@/components/atoms/SelectField";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
import FlexColumn from "../atoms/FlexColumn";
import Label from "../atoms/Label";
import ScoutMessageTemplateCreateDialog from "./ScoutMessageTemplateCreateDialog";
import Button from '../atoms/Button'
import ScoutMessageTemplateListDialog from "./ScoutMessageTemplateListDialog.vue";

export default {
  mixins: [ApiMixin],
  name: "JobSelectDialog",
  components: {
    ScoutMessageTemplateListDialog,
    Button,
    ScoutMessageTemplateCreateDialog,
    Label, FlexColumn, SelectField, FlexRow, TextButton, Dialog},
  props: {
    open: {
      type: Boolean,
      required: true
    },
    requestor: {
      type: Object,
    },
  },
  data() {
    return {
      requestorId: this.requestor.id,
      templateId: undefined,
      openMessageTemplateCreateDialog: false,
      openMessageTemplateListDialog: false,
      scoutMotivations: []
    }
  },
  mounted() {
    this.requestorId = this.$cookies.get('nishika.chat-requests-requestor')
    this.templateId = this.$cookies.get('nishika.chat-requests-scout-message-template')
    const motivations = this.$cookies.get('nishika.chat-requests-scout-motivations')
    this.scoutMotivations = motivations ? motivations.split(',').map(item => Number(item)) : []
  },
  computed: {
    ...mapGetters("client", ["company", "requestors"]),
    ...mapGetters("message", ["scoutTemplates"]),
    ...mapGetters("system", ["consts"]),
    requestorItems() {
      return this.requestors.map(requestor => ({
        label: `${requestor.lastName} ${requestor.firstName}`,
        value: requestor.id
      }))
    },
    templateItems() {
      return this.scoutTemplates.map(template => ({
        label: template.name,
        value: template.id,
      }))
    },
    motivations() {
      if (this.consts && this.consts.scoutMotivation) {
        return this.consts.scoutMotivation.map(item => ({
          value: item.value,
          name: item.label
        }))
      }
      return []
    },
  },
  methods: {
    handleSelect() {
      const expireTimes = 60 * 60 * 24 * 30
      this.$cookies.set('nishika.chat-requests-requestor', this.requestorId, expireTimes)
      this.$cookies.set('nishika.chat-requests-scout-message-template', this.templateId, expireTimes)
      this.$cookies.set('nishika.chat-requests-scout-motivations', this.scoutMotivations, expireTimes)
      this.$emit("select", this.requestorId)
    },
    handleInputScoutMotivation(checked, value) {
      if (checked) {
        this.scoutMotivations.push(value)
      } else {
        this.scoutMotivations = this.scoutMotivations.filter(item => item !== value)
      }
    },
  },
  watch: {
    requestor: {
      handler(value) {
        this.requestorId = value.id
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>